<template>
  <div class="fixed inset-0 select-none">
    <NuxtLoadingIndicator color="#80f5d2" />
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </div>

  <div class="fixed right-0 top-0 z-[10000]">
    <Toaster />
  </div>
</template>

<script setup lang="ts">
import Toaster from '@/components/ui/toast/Toaster.vue';
</script>
